import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { ValueState } from '@app/shared/types';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';

interface SingleValueNumberOutput {
  id: string;
  value: number;
}

@Component({
  selector: 'app-single-value-number',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './single-value-number.component.html',
  styleUrls: ['./single-value-number.component.css'],
})
export class SingleValueNumberComponent {
  @Input() public data: {
    state: ValueState;
    label: string;
  };
  @Output() output = new EventEmitter<SingleValueNumberOutput>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDataChange(value: any) {
    this.output.emit({
      id: this.data.state.id,
      value: value.target.value,
    });
  }
}
